import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Loader from './components/Loader';
import TawkTo from './components/TawkTo';

// Public Screens
const Home = lazy(() => import('./screens/Home'));
const About = lazy(() => import('./screens/About'));
const Error = lazy(() => import('./screens/Error'));
const Contact = lazy(() => import('./screens/Contact'));
const Services = lazy(() => import('./screens/Services'));
const Appointment = lazy(() => import('./screens/Book_Appointment'));


const App = () => (
  <Suspense fallback={<Loader />}>
    <TawkTo />
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/About-Us" element={<About />} />
      <Route path="/Contact-us" element={<Contact />} />
      <Route path="/Services" element={<Services />} />
      <Route path="/Book-Appointment" element={<Appointment />} />
      <Route path="*" element={<Error />} />
      
    </Routes>
  </Suspense>
);

export default App;
